import { useState, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { MyContext } from './context/UserProvider';

export default function LoginScreen() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [windowDimensions, setWindowDimensions] = useState({
    height: typeof window !== 'undefined' ? window.innerHeight : 0,
    width: typeof window !== 'undefined' ? window.innerWidth : 0,
  });

  const { login, setLogin, showTelaLogin, setShowTelaLogin, setShowUser } = useContext(MyContext);
  const navigate = useNavigate();

  // atualiza dimensões ao redimensionar
  useEffect(() => {
    const handleResize = () =>
      setWindowDimensions({ width: window.innerWidth, height: window.innerHeight });

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const isMobile = typeof windowDimensions.width === 'number' && windowDimensions.width < 968;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!email || !password) {
      setError('Por favor, preencha todos os campos.');
      return;
    }

    setLoading(true);

    try {
      const apiBase =
        process.env.REACT_APP_API_URL ||
        `${window.location.protocol}//${window.location.hostname}:3002`;

      const response = await fetch(`${apiBase}/api/getUsuarioByLoginRoyal`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          emailOrCpf: email,
          senha_hash: password,
        }),
      });

      // tenta ler JSON de forma segura
      let data;
      const ct = response.headers.get('content-type') || '';
      if (ct.includes('application/json')) {
        data = await response.json();
      } else {
        const text = await response.text().catch(() => '');
        try {
          data = JSON.parse(text);
        } catch {
          data = null;
        }
      }



      // adapta para o novo formato: backend pode devolver { usuario: {...}, enderecos: [...] }
      const userObj = data && data.usuario ? data.usuario : data;
      let enderecos = data && data.enderecos ? data.enderecos : null;

      if (!userObj || userObj.usuario_id == null) {
        setError('E-mail/CPF ou senha incorretos.');
      } else {
        // se não vier endereços no payload, tenta buscar por fallback (não é obrigatório que exista)
        if (!enderecos) {
          try {
            const r = await fetch(`${apiBase}/api/enderecos?usuario_id=${encodeURIComponent(userObj.usuario_id)}`, {
              method: 'GET',
              headers: { 'Content-Type': 'application/json' },
            });
            if (r.ok) {
              const maybe = await r.json().catch(() => null);
              if (Array.isArray(maybe)) enderecos = maybe;
              else if (maybe && Array.isArray(maybe.enderecos)) enderecos = maybe.enderecos;
            }
          } catch (err) {
            console.warn('Falha ao buscar endereços (fallback):', err);
          }
        }

        const combined = { ...userObj, enderecos: enderecos || [] };

        setShowUser(false);
        localStorage.setItem('usuario', JSON.stringify(combined));

        setLogin(true);
      }
    } catch (err) {
      console.error('Erro de login:', err);
      setError('Ocorreu um erro ao tentar fazer login.');
    } finally {
      setLoading(false);
    }
  };


  if (login) {
    return (
      <div style={{ textAlign: 'center', padding: '2rem', color: '#facc15' }}>
        <h1>ROYAL SOFÁS</h1>
        <p>Login realizado com sucesso!</p>
      </div>
    );
  }

  // ===== estilos mínimos para harmonizar desktop sem mexer no mobile =====
  const containerStyle = {
    display: 'flex',
    backgroundColor: '#fff',
    color: '#111827',
    width: isMobile ? '90%' : '480px',
    maxWidth: isMobile ? '460px' : '520px',
    fontFamily: '"Playfair Display", serif',
    zIndex: 9999,
    alignItems: 'center',
    justifyContent: 'center',
    padding: isMobile ? '1.5rem' : '2.25rem',
    borderRadius: isMobile ? '8px' : '12px',
    boxSizing: 'border-box',
    margin: isMobile ? '0 auto' : '40px auto', // empurra do topo no desktop
    boxShadow: isMobile ? undefined : '0 8px 30px rgba(0,0,0,0.08)',
  };

  const headingStyle = {
    fontSize: isMobile ? '2rem' : '2.25rem',
    fontWeight: 300,
    letterSpacing: '0.12em',
    color: '#facc15',
    margin: 0,
    lineHeight: 1,
  };

  const subtitleStyle = {
    color: '#6b7280',
    marginTop: '0.5rem',
    marginBottom: isMobile ? '1.5rem' : '2rem',
    fontSize: isMobile ? '0.95rem' : '1rem',
  };

  const labelStyle = { display: 'block', fontSize: '0.9rem', color: '#374151', marginBottom: '0.4rem' };

  const inputCommon = {
    width: '100%',
    padding: '0.75rem 0.9rem',
    backgroundColor: '#f9fafb',
    border: '1px solid #d1d5db',
    borderRadius: '0.5rem',
    color: '#111827',
    fontSize: '1rem',
    boxSizing: 'border-box',
  };

  const buttonStyle = {
    width: '100%',
    backgroundColor: '#facc15',
    color: '#000',
    fontWeight: 600,
    padding: '0.85rem',
    borderRadius: '0.6rem',
    border: 'none',
    cursor: loading ? 'not-allowed' : 'pointer',
    boxShadow: isMobile ? undefined : '0 6px 18px rgba(250, 204, 21, 0.18)',
  };

  return (
    <>
      {/* garante o keyframes do spinner caso não exista no projeto */}
      <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>

      <div onClick={(e) => e.stopPropagation()} style={containerStyle}>
        <div style={{ width: '100%' }}>
          {/* Cabeçalho */}
          <div style={{ textAlign: 'center', marginBottom: isMobile ? '1rem' : '1.25rem' }}>
            <h1 style={headingStyle}>ROYAL SOFÁS</h1>
          </div>

          <div style={{ textAlign: 'center', marginBottom: '1rem' }}>
            <h2 style={{ fontSize: isMobile ? '1.25rem' : '1.25rem', fontWeight: 300, margin: 0 }}>Bem-vindo de volta</h2>
            <p style={subtitleStyle}>Entre com suas credenciais para acessar sua conta</p>
          </div>

          {/* Erro */}
          {error && (
            <div
              style={{
                backgroundColor: '#fef2f2',
                border: '1px solid #fca5a5',
                padding: '1rem',
                color: '#b91c1c',
                marginBottom: '1rem',
                borderRadius: '0.5rem',
              }}
            >
              {error}
            </div>
          )}

          {/* Form */}
          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
            <div>
              <label htmlFor="email" style={labelStyle}>
                E-mail ou CPF
              </label>
              <input
                id="email"
                type="text"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Digite seu e-mail ou CPF"
                style={inputCommon}
              />
            </div>

            <div>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.25rem' }}>
                <label htmlFor="password" style={{ fontSize: '0.9rem', color: '#374151' }}>
                  Senha
                </label>
                <a href="#" style={{ fontSize: '0.9rem', color: '#facc15', textDecoration: 'none' }}>
                  Esqueceu a senha?
                </a>
              </div>
              <input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                style={inputCommon}
              />
            </div>

            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', fontSize: '0.95rem', color: '#6b7280' }}>
              <input type="checkbox" id="remember" />
              <label htmlFor="remember" style={{ margin: 0, color: '#6b7280' }}>
                Lembrar de mim
              </label>
            </div>

            <button type="submit" disabled={loading} style={buttonStyle}>
              {loading ? (
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <div
                    style={{
                      width: '18px',
                      height: '18px',
                      border: '2px solid #000',
                      borderTop: '2px solid transparent',
                      borderRadius: '50%',
                      animation: 'spin 1s linear infinite',
                      marginRight: '0.5rem',
                    }}
                  />
                  Entrando...
                </div>
              ) : (
                'Entrar'
              )}
            </button>
          </form>

          <p style={{ textAlign: 'center', fontSize: '0.95rem', color: '#6b7280', marginTop: '1.75rem' }}>
            Não tem uma conta?{' '}
            <a
              href="#"
              style={{ color: '#facc15', textDecoration: 'none', fontWeight: 600 }}
              onClick={() => {
                navigate('/CadastroScreen');
                setShowTelaLogin(false);
              }}
            >
              Registre-se
            </a>
          </p>
        </div>
      </div>
    </>
  );
}
